<template>
  <v-stepper-content step="3">
    <v-content fluid grid-list-lg style="padding: 0;">
      <v-layout row wrap>
        <v-flex xs12 v-if="!att.nopro">
          <v-subheader class="pl-0">Teeth</v-subheader>
          <select-teeth
            v-model="att.teeth"
            :disabled="lock"
            :error-messages="errs.teeth"
            @change="clearErr('teeth')"
          />
        </v-flex><v-flex xs12>
          <v-subheader class="pl-0">Steps</v-subheader>
          <small v-if="!Array.isArray(errs.stepIds)" class="error--text">
            {{errs.stepIds}}
          </small>
        </v-flex><v-flex
          v-for="(step, i) in steps"
          :key="step._id"
          xs12
          sm6
        >
          <v-checkbox
            class="text-capitalize"
            :label="step.name"
            v-model="att.stepIds"
            :value="step._id"
            :disabled="/pass\/fail/i.test(step.category) || lock || att.nopro || step.inputDisabled"
            :error-messages="(Array.isArray(errs.stepIds) && errs.stepIds[i]) || []"
            @change="clearErr('stepIds')"
          >
            <v-tooltip top slot="append" v-if="step.desc">
              <v-icon slot="activator" style="font-size: inherit;">far fa-question-circle</v-icon>
              <span>{{step.desc}}</span>
            </v-tooltip>
          </v-checkbox>
        </v-flex><v-flex xs12>
          <v-subheader class="pl-0">Comments for the Supervisor</v-subheader>
          <v-textarea
            label="Comments"
            v-model="att.comments.student"
            :disabled="lock || perm !== 'student'"
            :error-messages="errs.comments.student"
            @change="clearErr('comments.student')"
            :counter="4096"
          />
        </v-flex>
      </v-layout>
    </v-content>
    <v-btn @click="$emit('update:step', att.patreq ? 2 : 1)" >Back</v-btn>
    <v-btn
      v-if="perm !== 'student' || att.stat !== 'inprogress'"
      color="primary"
      @click="$emit('update:step', 4)"
      :disabled="!valid"
    >
      Continue
    </v-btn>
    <v-btn
      v-if="!lock"
      color="secondary"
      @click="$emit('save')"
      :disabled="!valid || id && !changed"
      :loading="loading"
    >
      Save
    </v-btn>
  </v-stepper-content>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import selectTeeth from '../../select-teeth.vue';
import attemptEq from '../attemptEq';

export default {
  components: {
    selectTeeth,
  },
  props: {
    attempt: {
      type: Object,
      default: () => ({ comments: {} }),
    },
    errs: {
      type: Object,
      default: () => ({ comments: {} }),
    },
    lock: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    changed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      att: { comments: {} },
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('attempts', ['get']),
    ...mapGetters('procedures', { proceduresFind: 'find' }),
    ...mapGetters('steps', { stepsFind: 'find' }),
    perm() { return this.user && this.user.perm; },
    id() { return this.att && this.att._id; },
    current() { return this.get(this.id) || {}; },
    valid() {
      return (this.att.nopro || (this.att.teeth && this.att.teeth.length))
        && this.att.stepIds && this.att.stepIds.length;
    },
    steps() {
      const pros = this.proceduresFind({
        query: { _id: { $in: (this.att && this.att.proIds) || [] } },
      }).data;
      const stepIds = pros.reduce((a, pro) => [...a, ...pro.stepIds], []);
      const steps = this.stepsFind({ query: { _id: { $in: stepIds }, $sort: { name: 1 } } }).data;
      return steps.map(step => ({
        ...step,
        grade: (this.att.grades.find(gr => gr.stepId === step._id) || {}).grade,
      }));
    },
  },
  methods: {
    setAtt() {
      if (!attemptEq(this.att, this.attempt)) this.att = cloneDeep(this.attempt);
    },
    clearErr(i) {
      const errs = cloneDeep(this.errors);
      set(errs, i, '');
      this.$emit('update:errors', errs);
    },
  },
  mounted() { this.setAtt(); },
  watch: {
    attempt: {
      handler() { this.setAtt(); },
      deep: true,
    },
    att: {
      handler() {
        if (!attemptEq(this.att, this.attempt)) this.$emit('update:attempt', this.att);
      },
      deep: true,
    },
    valid() { this.$emit('update:valid', this.valid); },
    steps() {
      if (!this.att || !this.att.stepIds || !this.steps.length) return;
      this.steps.forEach((step) => {
        if (
          (/pass\/fail/i.test(step.category) || step.inputDisabled || step.defaultChecked)
          && this.att.stepIds.indexOf(step._id) === -1
        ) this.att.stepIds.push(step._id);
      });
      this.att.stepIds.reverse().forEach((id, i) => {
        if (this.steps.find(step => step._id === id)) return;
        this.att.stepIds.splice(i, 1);
        this.att.grades = this.att.grades.filter(g => g.stepId !== id);
      });
    },
  },
};
</script>
